export const SYSTEM_KEY__UPDATE_EXAM_ITEM_STATS =
  "_system:update_exam_item_stats";

export const SYSTEM_KEY__UPDATE_USER_ACTIVITY_COUNT =
  "_system:update_user_activity_count";

export const SYSTEM_KEY__OBJECTIVE_ROOT_AUTHORITY = "_root_authority";
